import { ReactKeycloakProvider } from '@react-keycloak/web';
import { useLocation, useNavigate } from 'react-router-dom';
import keycloak, { keycloakLogout } from './config/keycloak';
import AppRouter from './AppRouter';

import { $user, resetUser, setUser } from 'models/user';
import { resetStores } from '@/models/store';
import { KeycloakTokenParsed } from 'keycloak-js';
import { useUnit } from 'effector-react';
import { reportError } from '@/utils/errors';
import { useCallback } from 'react';
import { normalizeKeycloakUser } from '@/utils/user';

const eventLogger = async (event: unknown, error: unknown) => {
  if (event === 'onTokenExpired') {
    try {
      await keycloak.updateToken(30);
    } catch (e) {
      console.error('Ошибка при обновлении токена:', e);
      reportError(e);
      keycloakLogout(keycloak);
    }
  }

  if (error) {
    reportError(error);
  }
};

const LoadingComponent = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-xl text-gray-600">Подключение к Keycloak...</div>
  </div>
);

const App = () => {
  const user = useUnit($user);
  const navigate = useNavigate();
  const location = useLocation();

  const tokenLogger = useCallback(() => {
    const tokenParsed: KeycloakTokenParsed = keycloak.tokenParsed!;

    if (tokenParsed) {
      setUser(normalizeKeycloakUser(tokenParsed));
    }

    if (!tokenParsed && user) {
      resetUser();
      resetStores();
      const encodedRef = encodeURIComponent(`${location.pathname}${location.search}`);
      navigate(`/login?ref=${encodedRef}`);
    }
  }, [location.pathname, location.search, navigate, user]);

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
      LoadingComponent={<LoadingComponent />}
    >
      <AppRouter />
    </ReactKeycloakProvider>
  );
};

export default App;
